'use client';

import React, { useEffect } from 'react';
import styles from './TopNavBar.module.scss';
import {
  BackButton,
  VolumeButton,
  ClosedCaptionsButton,
  ProgressBarSection,
} from '../TopNavBar';
import { usePlayer } from 'contexts/PlayerContext';
import { useAppDispatch, useAppSelector } from 'lib/hooks';
import { selectProgress, setProgress } from 'slices/navigationSlice';
import { usePathname } from 'next/navigation';
import type { ProgressStepsMap } from 'lib/progressSteps';

type TopNavBarProps = {
  progressSteps: ProgressStepsMap;
};

const TopNavBar: React.FC<TopNavBarProps> = ({ progressSteps }) => {
  const { player } = usePlayer();
  const dispatch = useAppDispatch();
  const pathname = usePathname();

  useEffect(() => {
    const step = progressSteps[pathname];
    if (step) {
      dispatch(setProgress(step));
    }
  }, [pathname, dispatch, progressSteps]);

  const progress = useAppSelector(selectProgress);

  return (
    <nav className={styles.topNavBar} aria-label="Progress navigation">
      <BackButton />

      <ProgressBarSection {...progress} />

      <div className={styles.audioAndCaptions}>
        {player && (
          <>
            <VolumeButton />
            <ClosedCaptionsButton />
          </>
        )}
      </div>
    </nav>
  );
};

export default TopNavBar;
